var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMwlogotop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.545,
    height: 27.692,
    viewBox: "0 0 31.545 27.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1082.383,701.647h6.787v-.863s-.5.028-1.1-.9a12.026,12.026,0,0,1-1.075-2.9l-3.285-11.806.034,14.094a1.559,1.559,0,0,1-1.359,1.543Z",
    transform: "translate(-1082.383 -673.955)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(1.141 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1215.38,676.36l-.287-1-2.676,8.907.354,1.288Z",
    transform: "translate(-1204.045 -664.85)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1226.012,714.63l-.307-1.068-2.7,8.933.352,1.285Z",
    transform: "translate(-1213.856 -700.258)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1220.72,695.206l-.289-1.007-2.68,8.95.346,1.259Z",
    transform: "translate(-1208.988 -682.312)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1209.734,656.509l-2.672,8.863c.122.442.25.908.368,1.338l2.6-9.15Z",
    transform: "translate(-1199.082 -647.379)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1236.908,754.113l-.346-1.207-2.736,8.945c.136.5.271.99.371,1.357Z",
    transform: "translate(-1223.887 -736.724)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1108.542,540.539l-.318-1.11-2.412,7.982,2.341-8.229-.317-1.105-2.009,6.576,1.95-6.781-.338-1.18-1.556,5.145,1.5-5.331-.348-1.214-1.21,3.958,1.167-4.106-.358-1.25-.824,2.7.8-2.8-.134-.469a2.313,2.313,0,0,0-.262-.61l-.4,1.19.354-1.261a1.635,1.635,0,0,0-1.331-.876c-1.4-.083-6.856-.029-6.856-.029v.876h2.089a1.38,1.38,0,0,1,.9.325,1.611,1.611,0,0,1,.386.5c.223.437,2.623,9.077,4.6,16.273Z",
    transform: "translate(-1097.979 -531.72)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1231.34,733.659l-.315-1.1-2.713,8.96.354,1.292Z",
    transform: "translate(-1218.777 -717.866)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1243.659,717.2l-1.3,4.2-.006-.02-2.765,8.915c.178.652.279,1.023.279,1.023l4.544-14.122Z",
    transform: "translate(-1229.229 -703.634)",
    fill: "#ec7600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2-2",
    "data-name": "Group 2",
    transform: "translate(12.416 0.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1382.979,733.671l-.187-.647-2.749,8.985.3,1.1Z",
    transform: "translate(-1370.682 -718.326)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1315.138,538.687q.138.491.286,1.016l2.24-7.406a1.349,1.349,0,0,0-.562-.13h-.07Z",
    transform: "translate(-1310.526 -532.162)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1321.549,545.13c.942,3.363,2.086,7.5,3.074,11.1l0-.043,2.591-9.239-.252-.868-2.315,7.535h-.048l2.234-7.979-.278-.959-1.907,6.219h-.049l1.83-6.654-.284-.978-1.49,4.919h-.056l1.457-5.228-.306-1.055-1.1,3.563h-.053l1.069-3.843-.322-1.112-.7,2.247h-.049l.683-2.465-.329-1.133-.316.9-.046-.018.308-1.062a3.365,3.365,0,0,0-.922-1.653Z",
    transform: "translate(-1316.468 -536.937)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1377.7,714.741l-.2-.7L1374.766,723l.3,1.11Z",
    transform: "translate(-1365.791 -700.728)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1388.114,751.871l-2.76,9.026.279,1.022,2.7-9.3Z",
    transform: "translate(-1375.604 -735.793)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1366.713,676.848l-2.732,8.813.36,1.31,0-.053,2.58-9.339Z",
    transform: "translate(-1355.796 -666.259)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1309.2,537.11q.118.414.246.867l1.693-5.859h-.447Z",
    transform: "translate(-1305.023 -532.118)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1372.238,696.385l-.193-.668-2.743,8.849.336,1.225Z",
    transform: "translate(-1360.726 -683.748)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1291.378,532.15H1291l-.357,1.205a1.568,1.568,0,0,1,.3.365Z",
    transform: "translate(-1287.823 -532.147)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1252.56,532.315l-.464,0,.018.847h.221Z",
    transform: "translate(-1252.097 -532.3)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1281.621,532.182l-.44,0-.238.857h0a1.225,1.225,0,0,1,.39.128Z",
    transform: "translate(-1278.834 -532.177)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1303.334,535.616q.115.395.249.859l1.266-4.36h-.453Z",
    transform: "translate(-1299.585 -532.114)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1398.661,532.347l-8.248,26.439c.2.738.329,1.206.329,1.206l8.68-27.646Z",
    transform: "translate(-1380.294 -532.33)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1297.794,534.271c.055.176.123.4.2.66l.788-2.805h-.343Z",
    transform: "translate(-1294.451 -532.125)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1258.785,533.117h.53l.225-.852-.522,0Z",
    transform: "translate(-1258.295 -532.254)",
    fill: "#ec7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1270.749,532.221l-.475,0-.233.854h.473Z",
    transform: "translate(-1268.728 -532.213)",
    fill: "#ec7600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMwlogotop);
export default __webpack_public_path__ + "static/media/mwlogotop.4a759dcc40c79878690a2c549e79eb1a.svg";
export { ForwardRef as ReactComponent };